import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import {
  InstagramAccountContext,
  InstagramAccountContextType,
} from "./InstagramAccountContext";

export const useInstagramAccount = (): InstagramAccountContextType => {
  const context = useContext(InstagramAccountContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useInstagramAccount",
      "InstagramAccountContext"
    );
  }

  return context;
};
